export default __webpack_public_path__ + "static/media/ic_close_modal_depre.10b057cb.svg";